import axios from "axios";
import dotEnv from "dotenv";
dotEnv.config();

const apiURL = process.env.REACT_APP_BASE_URL;

const transactionLaneApi = (data, role,userAuthKey, transactionType, propertyId) => {

  return axios.get(`${apiURL}/RTD/${data}?role=${role}&openFor=${role === "BUYER" ? "BUYER_AGENT" : "SELLER_AGENT"}${transactionType ? `&transactionType=${transactionType}` : ''}${propertyId ? `&propertyId=${propertyId}` : ''}`, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};


const updateDocumentApi = ({documentId, data, userAuthKey, emailSignatureId, emailMessage}) => {
 
  let apiUrl = `${apiURL}/offerDocument/${documentId}`;
  if (!data?.sellerAgentSigned) {
    delete data?.sellerAgentSigned;
  }
  return axios.put(
    apiUrl,
    {
      ...data,
       emailSignatureId,
       emailMessage
    },
    {
      headers: {
        accept: "application/json",
        authorization: `bearer ${userAuthKey}`,
      },
    }
  );
}

const sendEmailToClientRequest = (data,userAuthKey) => {
  return axios.post(`${apiURL}/offerDocument/sendDocument`, data, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const getNestedDoraDocuments = (data, accessToken, fiters) => { 
  return axios.get(`${apiURL}/nestedContractDocumentaries`, {
    params: {
      listType: data.listType,
      offerId: data.offerId,
      ...(fiters?.search && { search: fiters.search }), // Add search if it exists
      openFor: data?.openFor
    },
    headers: {
      accept: "application/json",
      authorization: `Bearer ${accessToken}`,
    },
  });
};

const uploadPdfDocument = ({data},accessToken) => {
  const payload = {
    ...(data?.fileLink && { fileLink: data.fileLink }),
    ...(data?.delegateSide && { delegateSide: data.delegateSide }),
    ...(data?.delegateOwnerId && { delegateOwnerId: data.delegateOwnerId }),
    ...(data?.screenType && { screenType: data.screenType }),
    ...(data?.offerId && { offerId: data.offerId }),
    ...(data?.contractId && { contractId: data.contractId }),
    ...(data?.contractType && { contractType: data.contractType }),
    ...(data?.RTDInitiator && { RTDInitiator: data.RTDInitiator }),
    ...(data?.openForPropertyDoc && { openForPropertyDoc: data.openForPropertyDoc }),
    ...(data?.propertyId && { propertyId: data.propertyId }),
    ...(data?.clientDocId && { clientDocId: data.clientDocId }),
    ...(data?.sellerIds?.length && { sellerIds: JSON.stringify(data.sellerIds) }),
    ...(data?.buyerIds?.length && { buyerIds: JSON.stringify(data.buyerIds) }),
    ...(Array.isArray(data?.buyerAgentIds) && data.buyerAgentIds.length && {
      buyerAgentIds: JSON.stringify(data.buyerAgentIds),
    }),
    ...(Array.isArray(data?.sellerAgentIds) && data.sellerAgentIds.length && {
      sellerAgentIds: JSON.stringify(data.sellerAgentIds),
    }),
  };
  return axios.post(`${apiURL}/uploadPdfDocument`, payload, {
      headers: {
         "Content-Type": "application/json",
          accept: "application/json",
          authorization: `bearer ${accessToken}`,
      },
  });
};
const getemailtemplateRequest = (userAuthKey) => {
  return axios.get(`${apiURL}/docAndClause/EMAIL_TEMPLATE`, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};
const urlShorthandApi = (data={}) => {
  return axios.post(
    `${apiURL}/url/builtForSection`,
    {
      ...data,
    },
    {
      headers: {
        accept: "application/json",
        authorization: `bearer ${data.token}`,
      },
    }
  );
};

// Update email
const updateEmailRequest = (values,personId,offerTableAuthKey) => {
    // let accessTokan = localStorage.getItem("auth");
    const params = new URLSearchParams();
    params.append("personId", personId);
    params.append("email", values.email);

    return axios.put(
      `${apiURL}/person/profileUpdateOfCustomerByRealtor`,
      params,
      {
        headers: {
          // "Content-Type": "application/x-www-form-urlencoded",
          accept: "application/json",
          authorization: `bearer ${offerTableAuthKey}`,
        },
      }
    );
  };

  const addEmailRequest = (accessTokan, data) => {
    return axios.post(`${apiURL}/addClientDetail`,{...data},{
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessTokan}`,
      },
    })
  }

  const getSharedDocsRequest = ({offerId, userAuthKey, openFor}) => {
    return axios.get(`${apiURL}/getSharedDocs`,
    {
      params: {
        offerId,
        openFor
      },
      headers: {
        accept: "application/json",
        authorization: `bearer ${userAuthKey}`,
      },
    });
  };
  const individualTransactionApi = ({ offerId, propertyId, sourceAxios, delegateSide, delegateOwnerId,userAuthKey, openFor }) => {
  return axios.get(`${apiURL}/getIndividualTransaction`, {
      cancelToken: sourceAxios?.token,
      params: {
        ...(offerId ? { offerId } : propertyId ? { propertyId } : {}),
        ...(delegateSide ? { delegateSide } : {}),
        ...(delegateOwnerId ? { delegateOwnerId } : {}),
        ...(openFor ? { openFor } : {}),
      },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${userAuthKey}`,
      },
    });
  };


const deletePropertyContractDocsRequest = ({ payloadData }) => {
  let documentId = payloadData?.documentId
  let params = {
    ...(payloadData?.offerId && { offerId: payloadData.offerId }),
    ...(payloadData?.isToggleFrom && { isToggleFrom: payloadData.isToggleFrom }),
    ...(payloadData?.openFor && { openFor: payloadData.openFor }),
    ...(payloadData?.isResureSignDoc && { isResureSignDoc: true }),
    ...(typeof payloadData?.showInTransactionDashboard === 'boolean'  && { showInTransactionDashboard:false })
  };

  return axios.delete(`${apiURL}/RTD/deleteForm/${documentId}`, {
    params,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${payloadData?.token}`,
    },
  });
};

const deletePropertyContractDocsFunRequest = ({ payloadData, userAuthKey }) => {
  let params = {
    ...(payloadData?.delegateSide && { delegateSide: payloadData.delegateSide }),
    ...(payloadData?.delegateOwnerId && { delegateOwnerId: payloadData.delegateOwnerId }),
    ...(payloadData?.offerId && { offerId: payloadData.offerId }),
    ...(payloadData?.propertyId && { propertyId: payloadData.propertyId }),
    ...(payloadData?.documentId && { documentId: payloadData.documentId }),
    ...(payloadData?.section && { section: payloadData.section }),
    ...(payloadData?.isResureSignDoc && { isResureSignDoc: true })
  };

  return axios.delete(`${apiURL}/propertydocs/deletecontracts`, {
    params,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${userAuthKey}`,
    },
  });
};

const getClientDocRequest = ({params, source, userAuthKey}) => {
  return axios.get(`${apiURL}/propertyDocs`, {
    cancelToken: source?.token,
    params,
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const getEmails_FilesApi = (params, userAuthKey) => {
  return axios.get(
    `${apiURL}/emailsAndFiles`,
    {
    params,
    headers: {
        accept: "application/json",
        authorization: `bearer ${userAuthKey}`,
      },
    }
  );
};

const getClientScreen = (params, userAuthKey) => {
  return axios.get(
    `${apiURL}/clientRTD`,
    {
      params,

    headers: {
        accept: "application/json",
        authorization: `bearer ${userAuthKey}`,
      },
    }
  );
};

const generateDashboardLinkApi = (payload, userAuthKey) => {
  return axios.post(`${apiURL}/generateDashboardLink`,
    payload,
  {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${userAuthKey}`,
    },
  })
}

const uploadPropertyDocsRequest = (data, userAuthKey) => {
  return axios.post(`${apiURL}/uploadPropertyDocs`, data, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const sharePropertyDocsRequest = (data, userAuthKey) => {
  return axios.post(`${apiURL}/sharePropertyDocs`, data, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const deleteListingRequest = ({docId, delegateOwnerId, userAuthKey}) => {
  return axios.delete(`${apiURL}/deleteClientDoc/${docId}`,{
    params: {
      ...(delegateOwnerId ? {delegateOwnerId} : {})
    },
    headers: {
      Accept: "application/json",
      authorization: `Bearer ${userAuthKey}`,
    },
  })
}

const deletepropertyDocsRequest = (documentId, userAuthKey) => {
  return axios.delete(`${apiURL}/propertyDocs/${documentId}`, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const toggleDocumentInTransactionDashboardRequest = ({ payloadData, userAuthKey }) => {
  let documentId = payloadData?.documentId
  let params = {
    ...(payloadData?.delegateSide && { delegateSide: payloadData.delegateSide }),
    ...(payloadData?.delegateOwnerId && { delegateOwnerId: payloadData.delegateOwnerId }),
    ...(payloadData?.offerId && { offerId: payloadData.offerId }),
    ...(payloadData?.propertyId && { propertyId: payloadData.propertyId }),
    ...(payloadData?.openFor && { openFor: payloadData.openFor }),
    ...(payloadData?.isToggleFrom && { isToggleFrom: payloadData.isToggleFrom }),
    ...(payloadData?.isResureSignDoc && { isResureSignDoc: true }),
    ...(typeof payloadData?.showInTransactionDashboard === 'boolean' && { showInTransactionDashboard: payloadData.showInTransactionDashboard })
  };
  return axios.delete(`${apiURL}/RTD/deleteForm/${documentId}`, {
    params,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${userAuthKey}`,
    },
  });
}

const getMoveToFolderFunRequest = ({ params, userAuthKey }) => {
  return axios.get(`${apiURL}/getFolderAndSubFoldersDataForPropertyDocs`, {
    params, 
    headers: {
      Accept: "application/json", 
      Authorization: `Bearer ${userAuthKey}`, 
    },
  });
};

const moveToFolderFunRequest = ({params, userAuthKey}) => {

  return axios.put(`${apiURL}/updateFolderDetailsInPropertyDocs`, params, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
}

const downloadAllFilesAsZipRequest = (payload, userAuthKey) => {
  return axios.post(`${apiURL}/downloadAllFilesAsZip`, payload, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
    responseType: "blob",
  });
}

const templateDataRequest = ({contractType, delegateOwnerId, search, userAuthKey}) => {
  return axios.get(`${apiURL}/templates`, {
    params: {
      ...(contractType ? { contractType } : {}),
      ...(search ? { search } : {}),
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
    },
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${userAuthKey}`,
    },
  });
};

const getPreNestedDoraDocuments = ({data, source, fiters, brokerageId, userAuthKey}) => {
  return axios.get(
    `${apiURL}/preNestedContractDocumentaries?listType=${data.listType}` + (fiters?.search ? `&search=${fiters.search}` : ""),
    {
      cancelToken: source.token,
      headers: {
        accept: "application/json",
        authorization: `bearer ${userAuthKey}`,
      },
    },
  );
};

const createFolderRequest = ({ newFolderData, userAuthKey }) => {

  return axios.post(`${apiURL}/addFolderInPropertyDocs`, newFolderData, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const updateFolderRequest = ({ folderData, userAuthKey }) => {

  return axios.put(`${apiURL}/updateFolderDetailsInPropertyDocs`, folderData, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const deletePropertyDocFolder = (folderId, userAuthKey) => {
  return axios.delete(`${apiURL}/deletePropertyDocsFolder/${folderId}`,{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${userAuthKey}`,
    },
  })
}
const changeDocNameApi = (urlData, documentId, userAuthKey) => {
  return axios.put(`${apiURL}/propertyDocs/${documentId}`,urlData,{
    headers:{
      Accept: "application/json",
      Authorization: `Bearer ${userAuthKey}`,
    }
  })
}
const getResure_SignDocs= (userAuthKey) => {
 return axios.get(`${apiURL}/resure-sign/forms`, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${userAuthKey}`,
    },
  });
};

const importResure_SignDocs = ( payload ,userAuthKey) => {
  

  return axios.post(`${apiURL}/resure-sign/shareFormsWithTransaction`, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${userAuthKey}`,
    },
  });
};

const generateresureSignApi = (data,userAuthKey) => {
  return axios.post(
    `${apiURL}/resure-sign/generateFormLink`,
    {
      ...data,
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${userAuthKey}`,
      },
    }
  );
};
export const transactionLaneDataApi = {
  generateresureSignApi,
  sendEmailToClientRequest,
  transactionLaneApi,
  updateDocumentApi,
  getNestedDoraDocuments,
  getemailtemplateRequest,
  urlShorthandApi,
  updateEmailRequest,
  addEmailRequest,
  getSharedDocsRequest,
  individualTransactionApi,
  deletePropertyContractDocsRequest,
  uploadPdfDocument,
  getClientDocRequest,
  getEmails_FilesApi,
  getClientScreen,
  generateDashboardLinkApi,
  uploadPropertyDocsRequest,
  sharePropertyDocsRequest,
  deleteListingRequest,
  deletepropertyDocsRequest,
  toggleDocumentInTransactionDashboardRequest,
  getMoveToFolderFunRequest,
  moveToFolderFunRequest,
  downloadAllFilesAsZipRequest,
  templateDataRequest,
  getPreNestedDoraDocuments,
  createFolderRequest,
  updateFolderRequest,
  deletePropertyDocFolder,
  deletePropertyContractDocsFunRequest,
  changeDocNameApi,
  getResure_SignDocs,
  importResure_SignDocs
};
